import createReducer from '../utils/createReducer';
import ListingActions from '../actions/listingActions';
import ListingPageActions from '../actions/listingPageActions';
import InquiryActions from '../actions/inquiryModalActions';
import {ListingPageRecord, OpenModalStates, InquiryStates} from '../records/listingPageRecord';
import {Map} from 'immutable';
import {mergeDeep} from '../utils/objectHelper';

const initialState = new ListingPageRecord();

const actionHandlers = {
    [ListingActions.UPDATE_MODAL_STATE](state, {payload = {modalState: OpenModalStates.NONE}}) {
        const {modalState} = payload;

        return state.merge({
            openModalState: modalState
        });
    },
    [ListingActions.LOADING_RATE](state, {payload = {loadingRate: true}}) {
        const {loadingRate} = payload;

        return state.merge({
            loadingRate
        });
    },
    [ListingActions.LOADED_RATE](
        state,
        {
            payload = {
                loadingRate: false,
                pricingInfo: {},
                priceDetails: {},
                pricingKey: new Map(),
                priceSummaryDetails: {}
            }
        }
    ) {
        const {loadingRate, pricingInfo, priceDetails, pricingKey, priceSummaryDetails} = payload;
        const {priceSummary, priceSummarySecondary, priceLabel} = priceSummaryDetails
            ? priceSummaryDetails
            : {};

        return state.merge({
            loadingRate,
            pricingInfo,
            priceDetails,
            pricingKey,
            priceSummary,
            priceSummarySecondary,
            priceLabel
        });
    },
    [ListingActions.PRICING_INFO_RESET](state, {payload = {pricingKey: new Map()}}) {
        const {pricingKey} = payload;

        return state.merge({
            pricingInfo: {},
            priceDetails: {},
            pricingKey
        });
    },
    [ListingActions.DATES_ARE_VALID](state, {payload = {validDates: {}}}) {
        const {validDates} = payload;
        const updatedValidity = mergeDeep(state.validDates, validDates);

        return state.mergeIn(['validDates'], updatedValidity);
    },
    [ListingActions.GUESTS_ARE_VALID](state, {payload = {validGuests: true}}) {
        const {validGuests} = payload;

        return state.merge({
            validGuests
        });
    },
    [InquiryActions.INQUIRY_POSTING](state, {payload = {}}) {
        const {inquiryUUID} = payload;
        return state.merge({
            inquiryUUID,
            inquiryState: InquiryStates.MSG_POSTING
        });
    },
    [InquiryActions.INQUIRY_SUCCESS](state, {payload = {}}) {
        const {inquiryUUID} = payload;
        return state.merge({
            inquiryUUID,
            inquiryState: InquiryStates.MSG_SEND_SUCCESS
        });
    },
    [InquiryActions.INQUIRY_ERROR](state, {payload = {}}) {
        const {inquiryServiceErrors} = payload;

        return state.merge({
            inquiryServiceErrors,
            inquiryState: InquiryStates.MSG_SEND_FAILURE
        });
    },
    [ListingActions.INQUIRY_MSG_RESET](state) {
        return state.merge({
            inquiryState: InquiryStates.NONE
        });
    },
    [ListingPageActions.ENTER_DATES_TIMER_COMPLETE](state, {payload = {}}) {
        const {enterDatesTimerComplete} = payload;

        return state.merge({
            enterDatesTimerComplete
        });
    },
    [ListingPageActions.TYPEAHEAD_INPUT_FOCUSED](state, {payload = {}}) {
        const {isFocused} = payload;

        return state.merge({
            isTypeaheadInputFocused: isFocused
        });
    },
    [ListingPageActions.SHOW_PROPERTY_DESCRIPTION_DISCLAIMER](state, {payload = {}}) {
        const {showDescriptionDisclaimerControl = state.showDescriptionDisclaimerControl} = payload;
        return state.merge({showDescriptionDisclaimerControl});
    },
    [ListingPageActions.TRANSLATE_PROPERTY_DESCRIPTION_FAILURE](state, {payload = {}}) {
        const {showAlert = state.showAlert} = payload;
        return state.merge({showAlert});
    },
    [ListingActions.PAGE_LOADED](state) {
        return state.merge({
            showMultiUnits: true
        });
    },
    [ListingPageActions.TRIP_SUMMARY_VISIBLE](state, {payload = {}}) {
        const {tripSummaryVisible = state.tripSummaryVisible} = payload;
        return state.merge({tripSummaryVisible});
    },
    [ListingPageActions.SHOW_DATE_PICKER_MODAL_DESKTOP](state, {payload = {}}) {
        const {showDatePickerModalDesktop = state.showDatePickerModalDesktop} = payload;
        return state.merge({showDatePickerModalDesktop});
    }
};

export default createReducer(actionHandlers, initialState);
